































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import dataProxy from "@/services/data-proxy.service";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class BirsanjePodataka extends mixins(ComponentBaseMixin) {
  godine = [];
  meseci = [];
  vrsteBrisanja = [
    {id: 1, text: "Gorivo"},
    {id: 2, text: "Tahograf"},
    {id: 3, text: "GPS"},
  ];
  select2Options = {
    minimumResultsForSearch: Infinity
  };
  selectedYear = new Date().getFullYear();
  vrstaBrisanja = 1;
  selectedMonth = 1;
  isBusy = false;

  async created() {
    this.godineIMeseciOptions();
  }

  godineIMeseciOptions() {
    this.meseci = [
      {value: 1, text: this.$i18n.t('januar')},{value: 2, text: this.$i18n.t('februar')},
      {value: 3, text: this.$i18n.t('mart')},{value: 4, text: this.$i18n.t('april')},
      {value: 5, text: this.$i18n.t('maj')},{value: 6, text: this.$i18n.t('jun')},{value: 7, text: this.$i18n.t('jul')},
      {value: 8, text: this.$i18n.t('avgust')},{value: 9, text: this.$i18n.t('septembar')},
      {value: 10, text: this.$i18n.t('oktobar')},{value: 11, text: this.$i18n.t('novembar')},
      {value: 12, text: this.$i18n.t('decembar')}
    ];
    const now = new Date();
    this.godine = [
      {value: now.getFullYear(), text: now.getFullYear()},
      {value: now.getFullYear() - 1, text: now.getFullYear() - 1},
      {value: now.getFullYear() - 2, text: now.getFullYear() - 2}
    ];
    this.meseci.unshift({value: '', text: '...'});
    this.meseci = this.meseci.map(m => ({id: m.value, text: m.text}));

    this.godine.unshift({value: '', text: '...'});
    this.godine = this.godine.map(g => ({id: g.value, text: g.text}));

  }

  async obrisi() {
    if (this.isBusy) return;
    try {
      this.isBusy = true;
      await dataProxy.obrisiPodatke(this.vrstaBrisanja, this.selectedYear, this.selectedMonth);
      this.showInfo("Podaci su uspešno obrisani");
    } catch (e) {
      this.showError("Greška prilikom brisanja podataka");
    } finally {
       this.isBusy = false;
    }
  }
}
